import { ISessionInfo } from '../types/ISessionInfo';
import { Request } from './Request';

export interface ISwitchSiteParams {
  urlName: string;
}

export interface ISwitchSiteResult extends ISessionInfo {
}

export class SwitchSiteRequest extends Request<ISwitchSiteParams, ISwitchSiteResult> {
  constructor(params: ISwitchSiteParams) {
    super('switchSite', params);
  }
}
